import * as React from "react"
import {Icon, SemanticICONS} from "semantic-ui-react"
import {PlaceCategory, PlaceType} from "../graphql/queries"
import {SemanticCOLORS} from "semantic-ui-react/dist/commonjs"

const CategoryIcon = new Map<PlaceCategory, SemanticICONS>([
  [PlaceCategory.Airport, "plane"],
  [PlaceCategory.Hospital, "hospital"],
  [PlaceCategory.Place, "marker"],
])

const CategoryColor = new Map<PlaceCategory, SemanticCOLORS>([
  [PlaceCategory.Airport, "grey"],
  [PlaceCategory.Hospital, "grey"],
  [PlaceCategory.Place, "grey"],
])

const TypeIcon = new Map<PlaceType, SemanticICONS>([
  [PlaceType.Train, "train"],
  [PlaceType.Tram, "subway"],
  [PlaceType.Place, "marker"],
])

interface Props {
  type: PlaceType
  category: PlaceCategory | null
}

export function PlaceIcon({type, category}: Props) {
  if (category && category !== "Place") {
    const name = CategoryIcon.get(category)
    const color = CategoryColor.get(category)
    return <Icon name={name} color={color} size="large" />
  }

  const name = TypeIcon.get(type)
  return <Icon name={name} color={"grey"} size="large" />
}



// WEBPACK FOOTER //
// ./src/components/PlaceIcon.tsx